/**
 * Return the first (and presumably only) option that matched the 'value'
 * provided.
 * Used for setting the value of a selector component.
 *
 * @param allOptions options available for a selector component
 * @param value
 * @return {*}
 */
export const optionByValue = (allOptions, value) => {
  return allOptions.find((o) => o.value === value);
};
